import { ICONS } from '@frontend/icons';
import React from 'react';

export interface DefaultBadgeProps {
    id?: string;
    label: React.ReactNode;
    styles?: {
        container?: {
            color?: string;
        };
        label?: string;
    };
    clearable?: {
        onClear: () => void;
    };
}

const ID = 'default-badge';

export const DefaultBadge = (props: DefaultBadgeProps) => {
    return (
        <div
            id={props.id}
            data-testid={props.id ?? ID}
            className={`inline-flex items-center justify-center gap-1 rounded-full px-2 py-1 ${props.styles?.container?.color ?? 'bg-brand-structure'}`}>
            <div className={`justify-start text-center text-sm font-semibold ${props.styles?.label ?? 'text-background-surface'}`}>{props.label}</div>
            {props.clearable && <ICONS.BUTTON.CLOSE onClick={props.clearable.onClear} />}
        </div>
    );
};
